import {pathOr} from 'ramda';

import {SelectorType} from 'constants/flow/flowTypes';

/**
 * Determines is quick search visible or not
 * @type {SelectorType<boolean>}
 */
export const isQuickSearchVisible: SelectorType<boolean> = pathOr(false, [
    'quickSearch',
    'isVisible',
]);

/**
 * Has quick search panel suggestions block or not?
 * @type {SelectorType<boolean>}
 */
export const withSuggestions: SelectorType<boolean> = pathOr(false, [
    'quickSearch',
    'withSuggestions',
]);

/**
 * Picks words for search input's placeholder
 * @type {SelectorType<string>}
 */
export const getSearchInputPlaceholder: SelectorType<string> = pathOr('', [
    'quickSearch',
    'placeholder',
]);

/**
 * Picks category name for focused searching in this category
 * @type {SelectorType<string>}
 */
export const getSearchingCategory: SelectorType<string> = pathOr('', [
    'quickSearch',
    'searchingCategory',
]);
